import { rightMini, variation } from "assets/icons";
import styled from "@emotion/styled";
import { Col, Modal, Typography } from "antd";
import { FC, useState } from "react";
import ProductVariationCreate from "./ProductVariationCreate";

interface ProductVariationCardProps {
  setVariants: (variants: VariantsInput) => void;
  variants: VariantsInput;
  setPrices: (prices: PricesInput) => void;
  prices: PricesInput;
  is_guid: boolean;
  is_inventory: boolean;
}


const ProductVariationCard:FC<ProductVariationCardProps> = ({ variants, setVariants, prices, setPrices, is_guid, is_inventory }) => {
  const [open, setOpen] = useState(false);


  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  

  return (
    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }}>
      <WrapperAll onClick={showDrawer}>
        <SpanIcon>{variation}</SpanIcon>
        <TextWrapper>
          <Typography.Text>ตัวเลือกสินค้า</Typography.Text>
        </TextWrapper>
        <RightWrapper>
          <Typography.Text style={{ color:  prices.length >  0 ? "#417B97"  :"#C4C4C4" }}>
          { prices.length > 0 ? "ตั้งค่าแล้ว": "ไม่ได้ตั้งค่า" }
          </Typography.Text>
          <IconWrapper onClick={showDrawer}>{rightMini}</IconWrapper>
        </RightWrapper>
      </WrapperAll>
      <Modal
        title="ตัวเลือกสินค้า"
        open={open}
        maskClosable={false}
        onCancel={onClose}
        width={1000}
        footer={null}
        style={{ top: 20 }}
      >
        <ProductVariationCreate setVariants={setVariants} variants={variants} setPrices={setPrices} prices={prices} onClose={onClose} is_guid={is_guid} is_inventory={is_inventory} />
      </Modal>
    </Col>
  );
};

export default ProductVariationCard;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const RightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 76px;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-start;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 8px;
`;

const TextWrapper = styled.div`
  width: 200px;
  height: 100%;
  background-color: #ffffff;
  padding: 27px 20px 0px 20px;
`;

